import { Controller } from "@hotwired/stimulus";

/**
 * Publication de bulletins — met à jour en direct les blocs « parents recevant »
 * et « parents sans accès » (+ compteurs et liste du modal) quand on (dé)coche
 * un parent. Travaille sur l'ENSEMBLE des parents disponibles (via un dataset
 * JSON), donc reste correct même quand la liste de gauche est filtrée par recherche.
 */
export default class extends Controller {
  static targets = [
    "data",
    "receivingCount",
    "noAccessCount",
    "receivingList",
    "noAccessList",
    "modalList",
    "viewAllWrap",
  ];
  static values = { emptyText: String };

  connect() {
    let parents = [];
    try {
      parents = JSON.parse(this.hasDataTarget ? this.dataTarget.textContent : "[]");
    } catch (_) {
      parents = [];
    }
    this.map = new Map(
      parents.map((p) => [String(p.id), { ...p, selected: !!p.selected }]),
    );
    this.render();
  }

  toggle(event) {
    const cb = event.currentTarget;
    const id = String(cb.dataset.pid);
    if (this.map && this.map.has(id)) {
      this.map.get(id).selected = cb.checked;
      this.render();
    }
  }

  render() {
    if (!this.map) return;
    const all = Array.from(this.map.values());
    const receiving = all.filter((p) => p.selected);
    const noAccess = all.filter((p) => !p.selected);

    this.receivingCountTargets.forEach((el) => (el.textContent = receiving.length));
    this.noAccessCountTargets.forEach((el) => (el.textContent = noAccess.length));
    if (this.hasReceivingListTarget) this.fillList(this.receivingListTarget, receiving.slice(0, 10));
    if (this.hasNoAccessListTarget) this.fillList(this.noAccessListTarget, noAccess);
    if (this.hasModalListTarget) this.fillModal(this.modalListTarget, receiving);
    if (this.hasViewAllWrapTarget) {
      this.viewAllWrapTarget.style.display = receiving.length > 10 ? "" : "none";
    }
  }

  fillList(ul, items) {
    if (!items.length) {
      ul.innerHTML =
        `<li style="font-style:italic; color:var(--ds-text-4);">${esc(this.emptyTextValue)}</li>`;
      return;
    }
    ul.innerHTML = items
      .map(
        (p) =>
          `<li class="flex items-center justify-between" style="color:var(--ds-text-1);">` +
          `<span>${esc(p.name)}</span>` +
          `<span style="font:400 12px var(--g4s-font-sans); color:var(--ds-text-3);">${esc(p.phone || "")}</span></li>`,
      )
      .join("");
  }

  fillModal(ul, items) {
    ul.innerHTML = items
      .map(
        (p) =>
          `<li class="flex items-center justify-between parent-modal-item" style="color:var(--ds-text-1); padding:4px 0;" ` +
          `data-name="${esc((p.name || "").toLowerCase())}" data-phone="${esc((p.phone || "").toLowerCase())}">` +
          `<span style="font-weight:500;">${esc(p.name)}</span>` +
          `<span style="font:400 12px var(--g4s-font-sans); color:var(--ds-text-3);">${esc(p.phone || "")}</span></li>`,
      )
      .join("");
  }
}

function esc(value) {
  const div = document.createElement("div");
  div.textContent = value == null ? "" : String(value);
  return div.innerHTML;
}
